import { render, staticRenderFns } from "./TipoEnvioEstadoCuentaResult.vue?vue&type=template&id=48b2bb97&scoped=true"
import script from "./TipoEnvioEstadoCuentaResult.vue?vue&type=script&lang=ts"
export * from "./TipoEnvioEstadoCuentaResult.vue?vue&type=script&lang=ts"
import style0 from "./TipoEnvioEstadoCuentaResult.vue?vue&type=style&index=0&id=48b2bb97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b2bb97",
  null
  
)

export default component.exports